import { withI18n } from 'react-i18next';
import TrackingDesktop from './TrackingInfoDesktop';

export const pureComponent = TrackingDesktop;
export default withI18n()(TrackingDesktop);
